import React, { useEffect, useRef, useState } from 'react';
import { Player, BigPlayButton, CurrentTimeDisplay, DurationDisplay, TimeDivider, VolumeMenuButton } from 'video-react';
import ControlBar from 'video-react/lib/components/control-bar/ControlBar';
import mp3icon from '../images/mp3icon.svg';
import PostActionItems from './generic-components/post/PostActionItems';
import { FullScreenIcon, ExitFullScreenIcon } from '../components/Icons'
const CarouselVideo = ({ id, src, ext, index, activeIndex, videoWidth, showFullScreen, videoStyles }) => {
  const ref = useRef();
  const [muted, setMuted] = useState(false);
  const [hideElements, setHideElements] = useState(false)

  const toggleMute = (muted) => {
    const isMuted = ref.current.muted = muted;
    setMuted(isMuted);
  }

const toggleFullscreen = (event) => {
  ref.current.toggleFullscreen()
  setHideElements(pre => !pre);
  if (showFullScreen && hideElements) {
    ref?.current?.load()
  }
}

document.addEventListener('fullscreenchange', exitHandler);
document.addEventListener('webkitfullscreenchange', exitHandler);
document.addEventListener('mozfullscreenchange', exitHandler);
document.addEventListener('MSFullscreenChange', exitHandler);

function exitHandler() {
    if (showFullScreen && !document.fullscreenElement && !document.webkitIsFullScreen && !document.mozFullScreen && !document.msFullscreenElement) {
      setHideElements(false);
      ref?.current?.load()
    }
}  

  const stopAllVideos = (src) => {
    document.querySelectorAll('.video-react-video').forEach((el) => {
      if (src !== el.getAttribute('src')) {
        el.pause()
      }
    })

    if (showFullScreen && !hideElements) {
      ref.current.toggleFullscreen()
      setTimeout(() => {
        setHideElements(pre => !pre);
      }, 100) 
    }
  }

  useEffect(() => {
    if (!showFullScreen) {

      let observer = new IntersectionObserver(
        (entry) => {
          if (entry[0].isIntersecting && !!ref?.current?.video?.video?.currentTime) {
            ref?.current?.play();
          } else {
            ref?.current?.pause();
          }
        },
        { threshold: 0.7 }
      );
      if (ref.current) {
        observer.observe(ref.current.manager.rootElement);
      }
    }
  }, []);

  const style = {
    width: '100%',
    height: '100%',
    position: 'relative',
  }

  return (
    <React.Fragment
    >
      <div
        className="video-container-custom"
        style={{ ...style }}
        >
        <Player
          poster={ext}
          ref={ref}
          src={src}
          muted={muted}
          onPlay={() => stopAllVideos(src)}
          preload={"none"}
          playsInline
          aspectRatio="16:9"
        >
          <BigPlayButton position="center" />
          <ControlBar
            autoHide={true}
            disableDefaultControls={(!hideElements && showFullScreen) && true}
          >
            {!showFullScreen && (hideElements ?
              <ExitFullScreenIcon onClick={toggleFullscreen} className='fullscreen-icon' />
              :
              <FullScreenIcon onClick={toggleFullscreen} className='fullscreen-icon' />
            )}
            {showFullScreen && hideElements && <ExitFullScreenIcon onClick={toggleFullscreen} className='fullscreen-icon' />}
          </ControlBar>
        </Player>
       
      </div>
    </React.Fragment>
  );
};

export default CarouselVideo;
